import { useCallback, useContext, useState } from "react";

import { GlobalContext } from "../Context/GlobalContext";

const useOrders = () => {
  const { api } = useContext(GlobalContext);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getUserCatalogOrders = useCallback(
    async ({ custMobile = "", pageIndex = "1", recordPerPage = "10" } = {}) => {
      try {
        setLoading(true);
        setError("");

        const payload = {
          userid: "",
          custMobile: String(custMobile || ""),
          pageIndex: String(pageIndex || "1"),
          recordPerPage: String(recordPerPage || "10"),
        };

        console.log("Orders API Payload:", payload);

        const response = await api.post(
          "/Order/v1.0/getUserCatalogOrdersChaafo",
          payload,
        );

        const responseData = response?.data;

        console.log("Orders API Response:", responseData);

        if (String(responseData?.responseCode) === "00") {
          const orderList = Array.isArray(responseData?.response)
            ? responseData.response
            : Array.isArray(responseData?.data)
              ? responseData.data
              : [];

          setOrders(orderList);
          setError("");
        } else {
          setOrders([]);

          setError(
            responseData?.responseMessage ||
              responseData?.message ||
              "Orders not found.",
          );
        }

        return responseData;
      } catch (apiError) {
        console.error("Orders API Error:", apiError);

        const errorMessage =
          apiError?.response?.data?.responseMessage ||
          apiError?.response?.data?.message ||
          apiError?.message ||
          "Unable to load orders.";

        setOrders([]);
        setError(errorMessage);

        return null;
      } finally {
        setLoading(false);
      }
    },
    [api],
  );

  const getOrderReceiptDetails = useCallback(
    async ({ orderid = "", platform = "" } = {}) => {
      const cleanOrderId = String(orderid || "").trim();

      if (!cleanOrderId) {
        throw new Error("Order ID is required.");
      }

      try {
        const payload = {
          orderid: cleanOrderId,
          platform: String(platform || ""),
        };

        console.log("Receipt API Payload:", payload);

        const response = await api.post(
          "/Order/v1.0/getOrderReceiptDetails",
          payload,
        );

      const responseData = response?.data;

      console.log("Receipt API Response:", responseData);

      return responseData;

      } catch (apiError) {
        console.error("Error fetching order receipt details:", apiError);

        throw new Error(
          apiError?.response?.data?.responseMessage ||
            apiError?.response?.data?.message ||
            apiError?.message ||
            "Unable to fetch receipt details.",
        );
      }
    },
    [api],
  );

  return {
    orders,
    loading,
    error,
    getUserCatalogOrders,
    getOrderReceiptDetails,
  };
};

export default useOrders;
